<template>
  <div class="">
    <v-dialog v-model="dialogjabber" persistent max-width="500">
      <v-card class="">
        <v-card-title class="primary white--text">Tambah JabberID</v-card-title>
        <v-card-text class="mt-4">
          <div><v-text-field prepend-icon="mdi-jabber" :rules="[rules.email]" v-model="newdata.jid" label="JabberId" ></v-text-field></div>
          <v-row>
            <v-col cols="12" md="9">
              <div><v-text-field prepend-icon="lock" counter maxlength="6"  :rules="[rules.otp]" type="number" v-model="newdata.otp" label="Kode OTP" ></v-text-field></div>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn small @click="dosendotp" v-if="normal" text class="accent mt-6">Kirim Kode</v-btn>
              <v-btn block disabled small v-else text class="mt-6">{{timerotp}}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn elevation="0" dark @click="setdialogjabber(false)" color="red">Tutup</v-btn>
          <v-btn elevation="0" @click="simpan" :disabled="newdata.jid.length===0 || newdata.otp.length===0" color="primary">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-divider/>
    <v-layout class="" row wrap>
      <v-col cols="12" lg="6" md="6" class="elevation-1">
        <v-toolbar elevation="0">
          <v-spacer/>
          <v-btn small elevation="0" class="ml-2" color="accent" dark @click.native="setdialogjabber(true)">
            <v-icon dark>add</v-icon>Tambah JabberID
          </v-btn>
        </v-toolbar>
        <v-divider/>
        <v-data-table
            :headers="headers"
            :items="jabberlist"
            class="elevation-0"
            item-key="id">
          <template v-slot:item.aksi="{ item }">
            <v-btn x-small dark fab text @click.native="hapus(item)" class="red ml-2">
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.status="{ item }">
            <div class="ma-4 text-xs-left">
              <v-chip
                  :color="colorStatus(item.status)"
                  small
                  text-color="white">
                {{ statusText(item.status) }}
              </v-chip>
            </div>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" lg="6" md="6">
        <div class="mt-4">Transaksi Pembelian Menggunakan ID Jabber</div>
        JabberID
        <ul>
          <li>arjuna@jb.irsmarket.com</li>
          <li>bima@jb.irsmarket.com</li>
          <li>sadewa@jb.irsmarket.com</li>
          <li>yudistira@jb.irsmarket.com</li>
          <li>nakula@jb.irsmarket.com</li>
        </ul>
        <div class="mt-2">Format Transaksi</div>
        <ul>
          <li v-for="item in formattrx" :key="item.nama">
            <div>
              <b>{{item.nama}}</b>
            </div>
           <i>{{item.format}}</i>
            <p><i>{{item.contoh}}</i></p>
          </li>
        </ul>
       <div class="mt-2">
         key: adalah API Secret yang dikirim melakui email registrasi
       </div>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'JabberTrxPage',
  data: () => ({
    normal: true,
    timerotp: 60,
    newdata: {
      jid: '',
      otp: '',
      sid: ''
    },
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 20 || 'Max 20 characters',
      otp: value => value.length === 6 || 'OTP 6 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid JabberId.'
      }
    },
    timeconetx: null,
    xxjabberlist: [
      {
        id: 1,
        jb: 'panji@jabberix.com',
        status: 1,
        created: '2021-10-20 10:10:10',
        updated: '2021-10-20 10:10:10'
      }
    ],
    headers: [
      {
        text: 'JabberID',
        value: 'jb',
        sortable: false
      },
      {
        text: 'Status',
        value: 'status',
        sortable: false
      },
      {
        text: 'Aksi',
        value: 'aksi',
        sortable: false
      }
    ],
    formattrx: [
      {
        nama: 'Cek Saldo',
        format: 'S.<key>',
        contoh: 'S.xnjeawe123'
      },
      {
        nama: 'Transaksi',
        format: 'trx.<idtrx>.<kodeproduk>.<tujuan>.<key>',
        contoh: 'trx.1192039.S10.081234567890.xcjex123'
      }
    ],
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      sortBy: ['id'],
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10)
    }
  }),
  mounted () {
    this.getJabberList(this.opsitable)
  },
  computed: {
    ...mapState('UserStore', ['dialogjabber', 'jabberlist', 'totaljabber']),
    ...mapState('SaldoStore', ['otpkey'])
  },
  beforeDestroy () {
    clearInterval(this.timeconetx)
  },
  methods: {
    ...mapActions('UserStore', ['setdialogjabber', 'getJabberList', 'addJabber', 'deletejabber']),
    ...mapActions('SaldoStore', ['getOtp']),
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    colorStatus (val) {
      if (val === 0) {
        return 'red'
      }
      if (val === 1) {
        return 'green'
      }
    },
    toupper (val) {
      return val.toUpperCase()
    },
    statusText (val) {
      if (val === 0) {
        return 'Disable'
      }
      if (val === 1) {
        return 'Enable'
      }
    },
    simpan () {
      this.newdata.sid = this.otpkey
      this.addJabber(this.newdata)
    },
    cleanInterval () {
      clearInterval(this.timeconetx)
    },
    dosendotp () {
      this.normal = false
      this.getOtp()
      if (this.timeconetx !== null) {
        this.timerotp = 60
      }
      this.timeconetx = setInterval(() => {
        if (this.timerotp > 0) {
          this.timerotp = this.timerotp - 1
        } else {
          this.normal = true
        }
      }, 1000)
    },
    hapus (val) {
      this.$confirm('Yakin akan Hapus ' + val.jb, { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.deletejabber(val.id)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
